import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { DimensionType } from "../../api/dimensionType";
import { namespaces } from "../../consts/i18n";
import usePotreeViewer from "../../hooks/usePotreeViewer";

// front, back, left, right, top, bottom
const BUTTON_TYPES = [
  {
    title: "cameraView.front",
    icon: "/images/viewer_frontview.svg",
    view: "F",
  },
  {
    title: "cameraView.back",
    icon: "/images/viewer_backview.svg",
    view: "B",
  },
  {
    title: "cameraView.left",
    icon: "/images/viewer_leftview.svg",
    view: "L",
  },
  {
    title: "cameraView.right",
    icon: "/images/viewer_rightview.svg",
    view: "R",
  },
  {
    title: "cameraView.top",
    icon: "/images/viewer_topview.svg",
    view: "U",
  },
  {
    title: "cameraView.bottom",
    icon: "/images/viewer_bottomview.svg",
    view: "D",
  },
];

const CameraViewControl = () => {
  const measureMode = useSelector((state) => state.measures.mode);
  const { t } = useTranslation(namespaces.viewer);

  const { setCameraView } = usePotreeViewer();

  const handleClickChangeView = (view) => (e) => {
    setCameraView(view);
  };

  const [controlPanelOpen, setControlPanelOpen] = useState(false);

  const handleOpenControlPanel = () => {
    setControlPanelOpen(true);
  };

  const handleCloseControlPanel = () => {
    setControlPanelOpen(false);
  };

  if (measureMode === DimensionType.DIMENSION_2D) return null;

  return (
    <>
      <div
        className={`flex flex-row items-center justify-center transition-all h-[36px] w-${
          controlPanelOpen ? 48 : 96
        } bg-[#ffffff] ease-in-out duration-300 rounded-full  shadow-sm shadow-[#ddd]`}
      >
        {!controlPanelOpen ? (
          <button
            title={t("viewControl.helpOpen")}
            onClick={handleOpenControlPanel}
            style={{
              "--image-url": `url(/images/viewer_cameraview_control.svg)`,
            }}
            className={
              "rounded-full w-[35px] h-[35px] hover:bg-primaryLight bg-[image:var(--image-url)] bg-no-repeat bg-center bg-[length:20px_20px]"
            }
          />
        ) : (
          <div className="flex flex-row">
            <button
              title={t("viewControl.helpClose")}
              onClick={handleCloseControlPanel}
              style={{
                "--image-url": `url(/images/viewer_cameraview_control_close.svg)`,
              }}
              className={
                "w-[18px] h-[18px] bg-[image:var(--image-url)] bg-no-repeat bg-center bg-contain ml-[10px]"
              }
            />
            <div className="flex flex-row gap-[18px] justify-center items-center mx-[18px]">
              {BUTTON_TYPES.map((button) => (
                <button
                  key={button.view}
                  title={t(button.title)}
                  style={{
                    "--image-url": `url(${button.icon})`,
                    "--image2-url": `url(${button.icon.replace(
                      ".svg",
                      "_h.svg",
                    )})`,
                  }}
                  className={
                    "w-[18px] h-[18px] bg-[image:var(--image-url)] hover:bg-[image:var(--image2-url)] bg-no-repeat bg-center bg-contain"
                  }
                  onClick={handleClickChangeView(button.view)}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CameraViewControl;
